import { useEffect } from "react";
function ContactIconFooter() {

     useEffect(() => {
        // Avoid injecting script multiple times
        if (document.getElementById("tawkScript")) return;

        var s1 = document.createElement("script");
        s1.id = "tawkScript";
        s1.async = true;
        s1.src = "https://embed.tawk.to/68cbd6f9fdd26519217a2448/1j5e3vg2p";
        s1.charset = "UTF-8";
        s1.setAttribute("crossorigin", "*");

        document.body.appendChild(s1);

        return () => {
        
            // Cleanup: remove script
                const tawkScript = document.getElementById("tawkScript");
                if (tawkScript) {
                    tawkScript.remove();
                }

            // Cleanup: remove Tawk widget container (iframe + div)
                const tawkWidget = document.querySelector("iframe[src*='tawk.to']");
                if (tawkWidget && tawkWidget.parentNode) {
                    tawkWidget.parentNode.remove();
                }

            // Cleanup: remove global Tawk API (to avoid leaks)
                if (window.Tawk_API) {
                    delete window.Tawk_API;
                }

        };
    }, []);
    
    return (
        <>
            {Number(localStorage.getItem('screenwidth')) > 100 && (
                <section>
                    <div className="container">
                        <div className="row">
                            {/* <a
                                target="_blank"
                                className="whatsapp_us"
                                href="https://api.whatsapp.com/send?text=Hello,%20Sending%20you%20message%20from%20https://acumenglobalreact.sjain.io/"
                            >
                                <div className="relative">
                                    <img alt="whatsapp" src="/assets/WhatsApp_icon.png" />
                                </div>
                            </a> */}
                            <a className="d-none" href="tel:+918714702941">
                                <span className="call_us h-14 w-14 ">
                                    <div className="relative h-14 w-14 ">
                                        <img
                                            alt="phone"
                                            className="h-14 w-14 bottom-0"
                                            src="/assets/phone-icon.png"
                                        />
                                    </div>
                                </span>
                            </a>
                        </div>
                    </div>
                </section>
            )
            }
        </>
    );
}

export default ContactIconFooter;
